import { History } from "history";
import { AppThunkAction } from "..";
import * as httpClient from "../../util/httpClient";
import * as services from "../service";
import * as familyAction from "../familyService/actions";
import * as CSIDActions from "../csid/actions";
import {
    GET_ACTIVE_ACCOUNT,
    GET_FAMILY_MEMBERS,
    IUserFamilyAccountInfo,
    KnownAction,
    SUBMIT_COMMUNICATION_METHOD,
    TERMS_AND_CONDITION_REACCEPTANCE,
    SET_CHILD_SUBCUSTOMER_ID,
    SET_HAS_IDF_FAMILY_SERVICE,
    SET_FAMILY_MEMBER_LOADER,
    SET_CHILD_DOB,
    SET_PREFERENCED_LANGUAGE,
    RECEIVE_CATALOG_PRODUCTS,
    GET_AGE_LIMIT,
    SET_LANGUAGE_CHANGE,
} from "./types";
import { SET_CHILD_ACCOUNT_SWITCH_REDIRECT_URL } from "../configurationService/types";
import { ezsServiceIds, idfServiceIds } from "../../config/UserServicesList";
import { MapUserServiceDTO } from "../common";
export const actionCreators = {
    submitLogin:
        (data: any, history: History, isSSOUser: Boolean): AppThunkAction<KnownAction> =>
        (dispatch, getState) => {
            dispatch({ type: "SUBMIT_LOGIN", userInfo: data });
            getTermsAncConditionReacceptance(dispatch);
            GetPartnerConfiguration(dispatch, getState);
            sessionStorage.setItem("isActionByCategoryCalled", "true");
            familyAction.getPFSFamilyMember(dispatch);
            if (!isSSOUser) {
                httpClient
                    .sendRequest("GET", "web/login/HandleMFAonLogin")
                    .then((loginMFAResponse) => {
                        if (loginMFAResponse.securityCode) {
                            httpClient.sendRequest("GET", "web/forgot-password/GetCommunicationOption").then((data) => {
                                const communicationMethodList = data.communicationMethodList;
                                dispatch({ type: SUBMIT_COMMUNICATION_METHOD, communicationMethodList: communicationMethodList });

                                if (communicationMethodList && Array.isArray(communicationMethodList) && communicationMethodList.length >= 2) {
                                    history.push("/generate-MFA");
                                } else {
                                    const requestBody = {
                                        NotificationMethod: 0,
                                        SecurityCode: loginMFAResponse.securityCode,
                                    };
                                    httpClient.sendRequest("POST", "web/login/send-mfa-secureCode", requestBody).then((data) => {
                                        history.push("/validate-MFA");
                                        dispatch({ type: "SELECT_COMMUNICATION_METHOD", selectedMethod: "EMAIL" });
                                    });
                                }
                                dispatch({ type: "SECURE_CODE", secureCode: loginMFAResponse.securityCode });
                            });
                        }
                        if (loginMFAResponse.isSuccess && loginMFAResponse.securityCode === null) {
                            if (data.forcePasswordUpdate || data.isPasswordExpired) {
                                history.push("/reset-password");
                            } else {
                                const appState = getState();
                                GetServiceDetails(dispatch, history, appState.checkContractChangeState.fromRedirectUrl, "", appState);
                                getTermsAncConditionReacceptance(dispatch);
                            }
                        }
                    })
                    .catch(function (error) {});
            }
            return;
        },

    sendMFA: (data: any) => {
        const requestBody = {
            NotificationMethod: 0,
            SecurityCode: data.securityCode,
        };
        httpClient.sendRequest("POST", "web/login/send-mfa-secureCode", requestBody).then((data) => {
        });
    },
    getFamilyMembers:
        (reload: boolean): AppThunkAction<KnownAction> =>
        (dispatch, getState) => {
            let appState = getState();
            let userAccountType = "";

            if (appState.loggedInUser && appState.loggedInUser.activeAccount && appState.loggedInUser.activeAccount.accountType) {
                userAccountType = appState.loggedInUser.activeAccount.accountType;
            }

            if (userAccountType !== "PRIMARY") {
                return;
            }

            if (appState.loggedInUser && appState.loggedInUser.familyMembers && !reload) {
                return;
            }

            dispatch({ type: SET_FAMILY_MEMBER_LOADER, isLoadingFamilyMember: true });

            services
                .getUserFamily()
                .then((data) => {
                    if (data["hasFamilyService"]) {
                        dispatch({ type: SET_HAS_IDF_FAMILY_SERVICE, hasFamilyService: data["hasFamilyService"] });
                    }
                    if (!data["hasError"] && data["familyMembers"]) {
                        dispatch({ type: GET_FAMILY_MEMBERS, familyMembers: data["familyMembers"] });
                    }
                    if (!data["hasError"] && data.maxAgeLimit && data.minAgeLimit) {
                        const { maxAgeLimit, minAgeLimit } = data;
                        dispatch({ type: GET_AGE_LIMIT, ageLimit: { maxAgeLimit, minAgeLimit } });
                    }
                    dispatch({ type: SET_FAMILY_MEMBER_LOADER, isLoadingFamilyMember: false });
                })
                .catch(function (error) {
                    dispatch({ type: SET_FAMILY_MEMBER_LOADER, isLoadingFamilyMember: false });
                });
        },
    updateFamilyMember:
        (familyMembers: any): AppThunkAction<KnownAction> =>
        (dispatch, getState) => {
            dispatch({ type: GET_FAMILY_MEMBERS, familyMembers: familyMembers });
        },
    switchFamilyAccount:
        (activeAccount: IUserFamilyAccountInfo, history: History, familyMembers: IUserFamilyAccountInfo[]): AppThunkAction<KnownAction> =>
        (dispatch, getState) => {
            dispatch({ type: GET_FAMILY_MEMBERS, familyMembers });
            dispatch({ type: GET_ACTIVE_ACCOUNT, activeAccount });
            dispatch({ type: "RELOAD_USER_PERMISSION" });
            const appState = getState();
            const childAccountSwitchRedirectURL = appState.configurationState?.childAccountSwitchRedirectURL;
            GetServiceDetails(dispatch, history, appState.checkContractChangeState.fromRedirectUrl, childAccountSwitchRedirectURL, appState);
        },
    logout:
        (history: History, redirectURL?: string): AppThunkAction<KnownAction> =>
        (dispatch, getState) => {
            const appState = getState();
            httpClient
                .sendRequest("GET", "web/logout")
                .then(() => {
                    dispatch({ type: "USER_LOGGED_OUT" });
                    if (
                        appState &&
                        appState.configurationState &&
                        appState.configurationState.configuration &&
                        appState.configurationState.configuration.partnerConfig &&
                        appState.configurationState.configuration.partnerConfig &&
                        appState.configurationState.configuration.partnerConfig.ssoOptions &&
                        appState.configurationState.configuration.partnerConfig.ssoOptions.clientId
                    ) {
                        const { clientId, logoutURL } = appState.configurationState.configuration.partnerConfig.ssoOptions;
                        if (appState.configurationState.configuration.userAuthStatus === "SSO") {
                            window.location.href = `${logoutURL}?client_id=${clientId}&returnTo=${decodeURIComponent(encodeURIComponent(window.location.origin))}/app/login`;
                        }
                    }
                    if (Boolean(redirectURL)) {
                        window.open("https://" + redirectURL, "_self");
                    } else {
                        history.push("/Logout");
                    }
                })
                .catch(function (error) {
                    dispatch({ type: "USER_LOGGED_OUT" });
                    history.push("/Logout");
                });
        },
    authenticateForgotPasswordFlow:
        (data: any, history: History, addSecurityQuestion: boolean): AppThunkAction<KnownAction> =>
        (dispatch, getState) => {
            const appState = getState();
            dispatch({ type: "SUBMIT_LOGIN", userInfo: data });
            getTermsAncConditionReacceptance(dispatch);
            familyAction.getPFSFamilyMember(dispatch);
            GetPartnerConfiguration(dispatch, getState);
            GetServiceDetails(
                dispatch,
                history,
                appState.checkContractChangeState.fromRedirectUrl,
                addSecurityQuestion ? "/update-security-question" : "",
                appState
            );
        },
    acceptTermsAndCondition: (): AppThunkAction<KnownAction> => (dispatch) => {
        dispatch({
            type: TERMS_AND_CONDITION_REACCEPTANCE,
            termsAndConditionsReacceptance: {
                isTermsAndConditionUpdated: false,
                termsAndConditions: "",
            },
        });
    },
    setChildSubCustomerIDToCompleteAccountSetup:
        (subCustomerID: string): AppThunkAction<KnownAction> =>
        (dispatch) => {
            dispatch({
                type: SET_CHILD_SUBCUSTOMER_ID,
                childSubcustomerIdToCompleteAccount: subCustomerID,
            });
        },
    setChildDOBToCompleteAccountSetup:
        (dob: string): AppThunkAction<KnownAction> =>
        (dispatch) => {
            dispatch({
                type: SET_CHILD_DOB,
                childDOBToCompleteAccount: dob,
            });
        },
    updateSmbServiceDetails: (): AppThunkAction<KnownAction> => (dispatch) => {
        httpClient
            .sendRequest("GET", `api/userServices/Get-User-Active-Service-Details`)
            .then((data) => {
                const userServiceDetails = {
                    hasVpn: data["hasVpn"],
                    isBusinessUser: data["isBusinessUser"],
                    userServices: MapUserServiceDTO(data["userServiceDTO"]),
                    businessProfileStatus: data["businessProfileStatus"],
                    isBCMMonitored: data["isBCMMonitored"],
                    lmsRedirectUrl: data["lmsRedirectUrl"],
                    isNYStateUser: data["isNYStateUser"],
                };

                dispatch({ type: "GET_USER_SERVICES", userServiceDetails: userServiceDetails });
            })
            .catch(function (error) {
                console.log(error);
            });
    },
    SetPreferencedLanguage:
        (preferedLanguage: string, updateUsersLanguagePreference: boolean): AppThunkAction<KnownAction> =>
        (dispatch, getState: any) => {
            const state = getState();

            if (updateUsersLanguagePreference && state != null && state.configurationState != null && !!state.configurationState.partnerLanguageOptions) {
                const selectedLang = state.configurationState.partnerLanguageOptions.filter(
                    (lang: any) => lang.code.toLowerCase() === preferedLanguage.toLowerCase()
                );

                if (!!selectedLang) {
                    services.saveUserLanguagePreference(selectedLang[0].id);
                }
            }
            dispatch({ type: SET_PREFERENCED_LANGUAGE, preferencedLanguage: preferedLanguage.toLowerCase() });
        },
    LanguageChange:
        (updateUsersLanguagePreference: boolean): AppThunkAction<KnownAction> =>
        (dispatch, getState: any) => {
            let languageChanged = updateUsersLanguagePreference;
            dispatch({ type: SET_LANGUAGE_CHANGE, hasLanguageChanged: languageChanged });
        },
    updateLoggedInUserPhone:
        (phoneNumber: string): AppThunkAction<KnownAction> =>
        (dispatch, getState) => {
            const state = getState();
            if (state != null && state.loggedInUser != null) {
                dispatch({ type: "SET_USER_PHONE", phoneNumber: phoneNumber });
            }
        },
};

export function getTermsAncConditionReacceptance(dispatch: any) {
    services
        .getPartnerLatestTermsConditions()
        .then((data) => {
            if (data.isSuccess) {
                if (data.isTermsAndConditionUpdated && data.legalDocuments && data.legalDocuments.length > 0 && data.legalDocuments[0].value) {
                    dispatch({
                        type: TERMS_AND_CONDITION_REACCEPTANCE,
                        termsAndConditionsReacceptance: {
                            isTermsAndConditionUpdated: true,
                            termsAndConditions: data.legalDocuments[0].value,
                        },
                    });
                }
            }

            //dispatch({ type: 'GET_USER_SERVICES', userServices: data });
        })
        .catch(function (error) {});
}

export function GetPartnerConfiguration(dispatch: any, getState: any) {
    services
        .getPartnerConfig()
        .then((data) => {
            const appState = getState();
            console.log('suceess:: state in loginService ===>>', appState);

            if (appState.configurationState) {
                dispatch({
                    type: "RECEIVE_CONFIGURATION",
                    configuration: {
                        ...appState.configurationState.configuration,
                        partnerConfig: data,
                    },
                });
            }
        })
        .catch(function (error) {
            const appState = getState();
            console.log('catch:: state in loginService ===>>', appState?.configurationState);

            if (appState.configurationState) {
                if(appState?.configurationState?.configuration.partnerConfig.partnerId === 2664) {
                    window.location.href = 'https://my.malwarebytes.com';
                }
                dispatch({
                    type: "RECEIVE_CONFIGURATION",
                    configuration: {
                        ...appState.configurationState.configuration,
                        partnerConfig: {},
                    },
                });
            }
        });

    dispatch({ type: "REQUEST_CONFIGURATION" });
}
const logout = (dispatch: any, history: any) => {
    dispatch({ type: "USER_LOGGED_OUT" });
    history.push("/Login");
};
export function GetServiceDetails(
    dispatch: any,
    history: any,
    fromRedirectUrl?: boolean,
    childAccountSwitchRedirectURL?: string,
    appState?: any,
    hasCCAM?: boolean
) {
    const redirectTokenUrl =
        appState && appState.configurationState && appState.configurationState.redirectToken
            ? appState.configurationState.redirectToken
            : childAccountSwitchRedirectURL
            ? childAccountSwitchRedirectURL
            : "";
    const ccamService = appState?.loggedInUser?.userServiceDetails?.userServices?.find(
        (service: any) => service.serviceCode === ezsServiceIds.smartSSNTrackerChild
    );
    const idfccamService = appState?.loggedInUser?.userServiceDetails?.userServices?.find(
        (service: any) => service.serviceCode === idfServiceIds.childCreditActivityMonitoring
    );
    const ccamActive = (ccamService && ccamService.active) || (idfccamService && idfccamService.active) ? true : false;
    const isPrimaryAccount =
        appState.loggedInUser && appState.loggedInUser.activeAccount && appState.loggedInUser.activeAccount.accountType === "PRIMARY" ? true : false;

    dispatch({
        type: SET_CHILD_ACCOUNT_SWITCH_REDIRECT_URL,
        childAccountSwitchRedirectURL: "",
    });

    getCatalogProducts(dispatch, appState);

    CSIDActions.getCSIDStatus(dispatch);

    let isIDFUser: boolean;
    // IS IDF USER
    services.isIdfUser().then((isIDFData) => {
        isIDFUser = isIDFData;
        if (isIDFUser) {
            // IF PACKAGE CANCELLED
            services
                .GetIDFPackageCancellationStatus()
                .then((packageCancellationStatus) => {
                    if (packageCancellationStatus != null && packageCancellationStatus.processed != null) {
                        // not getting any service for cancelled user in IDF
                        if (redirectTokenUrl) {
                            history.push(redirectTokenUrl);
                        } else {
                            history.push("/manage-account/protection-plan");
                        }
                    } else {
                        httpClient
                            .sendRequest("GET", `api/userServices/Get-User-Active-Service-Details`)
                            .then((data) => {
                                const userServiceDetails = {
                                    hasVpn: data["hasVpn"],
                                    isBusinessUser: data["isBusinessUser"],
                                    userServices: MapUserServiceDTO(data["userServiceDTO"]),
                                    businessProfileStatus: data["businessProfileStatus"],
                                    isBCMMonitored: data["isBCMMonitored"],
                                    lmsRedirectUrl: data["lmsRedirectUrl"],
                                    isNYStateUser: data["isNYStateUser"],
                                };
                                dispatch({ type: "GET_USER_SERVICES", userServiceDetails: userServiceDetails });
                                if (isPrimaryAccount) {
                                    if (!ccamActive) {
                                        const idfccamService = data["userServiceDTO"].find(
                                            (service: any) => service.serviceCode === idfServiceIds.childCreditActivityMonitoring
                                        );
                                        const isCcamActive = !!idfccamService ? true : false;
                                        dispatch({ type: "SET_HAS_CCAM", hasCCAM: isCcamActive });
                                    }
                                }
                                GetChildEnrollmentDetails(dispatch, appState);
                                if (childAccountSwitchRedirectURL) {
                                    dispatch({
                                        type: SET_CHILD_ACCOUNT_SWITCH_REDIRECT_URL,
                                        childAccountSwitchRedirectURL: "",
                                    });
                                    history.push(childAccountSwitchRedirectURL);
                                } else {
                                    if (redirectTokenUrl) {
                                        history.push(redirectTokenUrl);
                                    } else {
                                        history.push("/dashboard");
                                    }
                                }
                            })
                            .catch(function (error) {
                                logout(dispatch, history);
                            });
                    }
                })
                .catch(function (error) {
                    logout(dispatch, history);
                });
        } else {
            // EZS user login
            httpClient
                .sendRequest("GET", `api/userServices/Get-User-Active-Service-Details`)
                .then((data) => {
                    const userServiceDetails = {
                        hasVpn: data["hasVpn"],
                        isBusinessUser: data["isBusinessUser"],
                        userServices: MapUserServiceDTO(data["userServiceDTO"]),
                        businessProfileStatus: data["businessProfileStatus"],
                        isBCMMonitored: data["isBCMMonitored"],
                        lmsRedirectUrl: data["lmsRedirectUrl"],
                        isNYStateUser: data["isNYStateUser"],
                    };

                    dispatch({ type: "GET_USER_SERVICES", userServiceDetails: userServiceDetails });
                    if (isPrimaryAccount) {
                        if (!ccamActive) {
                            const ccamService = data["userServiceDTO"].find((service: any) => service.serviceCode === ezsServiceIds.smartSSNTrackerChild);
                            const isCcamActive = !!ccamService ? true : false;
                            dispatch({ type: "SET_HAS_CCAM", hasCCAM: isCcamActive });
                        }
                    }
                    GetChildEnrollmentDetails(dispatch, appState);
                    services
                        .GetContractChangeDetails()
                        .then((data) => {
                            if (data != null && data !== "") {
                                let contractChangeJSON = JSON.parse(data);

                                if (contractChangeJSON.ContractStatus === "CHANGE" || contractChangeJSON.ContractStatus === "CHANGE_COMPLETE") {
                                    if (redirectTokenUrl) {
                                        history.push(redirectTokenUrl);
                                    } else {
                                        history.push("/dashboard");
                                    }
                                } else if (contractChangeJSON.ContractStatus === "CANCELLATION_CHANGE_COMPLETE" && fromRedirectUrl) {
                                    if (redirectTokenUrl) {
                                        history.push(redirectTokenUrl);
                                    } else {
                                        history.push("/dashboard");
                                    }
                                } else {
                                    services
                                        .getActiveOfferDetails()
                                        .then((data: any) => {
                                            dispatch({ type: "GET_ACTIVE_PACKAGE_ENROLLMENT", activePackage: data });
                                            if (data != null) {
                                                if (!data.isActive) {
                                                    history.push("/manage-account/protection-plan");
                                                } else {
                                                    if (redirectTokenUrl) {
                                                        history.push(redirectTokenUrl);
                                                    } else {
                                                        history.push("/dashboard");
                                                    }
                                                }
                                            } else {
                                                if (redirectTokenUrl) {
                                                    history.push(redirectTokenUrl);
                                                } else {
                                                    history.push("/dashboard");
                                                }
                                            }
                                        })
                                        .catch(function (error) {
                                            logout(dispatch, history);
                                        });
                                }
                            } else {
                                if (redirectTokenUrl) {
                                    history.push(redirectTokenUrl);
                                } else {
                                    history.push("/dashboard");
                                }
                            }
                        })
                        .catch(function (error) {
                            logout(dispatch, history);
                        });
                })
                .catch(function (error) {
                    logout(dispatch, history);
                });
        }
    });
}

function GetChildEnrollmentDetails(dispatch: any, appState: any) {
    const childStatus = appState.loggedInUser && appState.loggedInUser.userInfo?.childrenList ? appState.loggedInUser.userInfo?.childrenList : [];
    if (childStatus.length <= 0) {
        services.getChildEnrollmentStatus().then((childEnrollmentData) => {
            if (childEnrollmentData && childEnrollmentData.data && childEnrollmentData.data.children && childEnrollmentData.data.children.length > 0) {
                const childMonitoringData = childEnrollmentData.data.children.map((child: any) => {
                    return {
                        enrollmentStatusReason: child.enrollmentStatusReason,
                        subAccountPk: child.subAccountPk,
                        unenrollmentStatusReason: child.unenrollmentStatusReason,
                        errorMessage: child.errorMessage,
                    };
                });
                dispatch({ type: "SET_SUCCESSFUL_ENROLLED_CHILD_LIST", childrenList: childMonitoringData });
                dispatch({ type: "SET_MONITORED_CHILD_COUNT", numChildrenMonitored: childEnrollmentData.data.numChildrenMonitored });
            }
        });
    }
}

export function getCatalogProducts(dispatch: any, appState: any) {
    const catalogProductState = appState.loggedInUser && appState.loggedInUser.catalogProducts ? appState.loggedInUser.catalogProducts : [];
    if (catalogProductState.length === 0) {
        services
            .getCatalogProducts()
            .then((data) => {
                data = JSON.parse(data);
                if (data) {
                    const filteredProducts = data.productContent.filter((product: any) => product.ServiceCode.includes("SVCLVL-TU-CRDRPT"));
                    const hasPurchaseCreditReport = filteredProducts && filteredProducts.length > 0 ? true : false;

                    dispatch({
                        type: RECEIVE_CATALOG_PRODUCTS,
                        catalogProducts: data.productContent,
                        oneTimeProducts: filteredProducts,
                        hasPurchaseCreditReport: hasPurchaseCreditReport,
                    });
                }
            })
            .catch(function (error) {});
    }
}
